import { render } from "./SucursalForm.vue?vue&type=template&id=5d177098&scoped=true"
import script from "./SucursalForm.vue?vue&type=script&lang=js"
export * from "./SucursalForm.vue?vue&type=script&lang=js"

import "./SucursalForm.vue?vue&type=style&index=0&id=5d177098&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d177098"]])

export default __exports__